export * from './di-container-service.js';
export * from './app-di-container-service.js';
//# sourceMappingURL=index.js.map